import * as Result from './Result'

// tslint:disable-next-line no-any
export function parse(json: string): Result.Result<string, any> {
    return Result.fromError(
        (error): string => error.message,
        () => JSON.parse(json),
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Data/JsonHelper.ts